import { Injectable } from '@angular/core';
import { AnalyticsSupabaseService } from '@examdojo/supabase';
import { BehaviorSubject, finalize, from, map, Observable, tap } from 'rxjs';
import { mapStudentInsightsRpcRowToUIModel, StudentInsightsUIModel } from './student-insights.model';

// TODO: Refactor to use store + query instead of BehaviorSubjects
@Injectable()
export class StudentInsightsService {
  constructor(private readonly supabase: AnalyticsSupabaseService) {}

  private readonly data$$ = new BehaviorSubject<StudentInsightsUIModel | null>(null);
  private readonly loading$$ = new BehaviorSubject<boolean>(false);

  readonly data$ = this.data$$.asObservable();
  readonly loading$ = this.loading$$.asObservable();

  fetch(classId: string, studentId: string): Observable<StudentInsightsUIModel> {
    this.data$$.next(null);
    this.loading$$.next(true);

    return from(
      this.supabase.client
        .schema('classroom')
        .rpc('get_student_insights', { p_class_id: classId, p_student_id: studentId }, { get: true })
        .throwOnError()
        .then((response) => response.data?.[0] ?? null),
    ).pipe(
      map((row) => mapStudentInsightsRpcRowToUIModel(row)),
      tap((insights) => this.data$$.next(insights)),
      finalize(() => this.loading$$.next(false)),
    );
  }

  reset(): void {
    this.data$$.next(null);
    this.loading$$.next(false);
  }
}
